export default __webpack_public_path__ + "static/media/Background_00029.d190e547.png";